/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {
    Component, OnInit
} from '@angular/core';
import * as _ from 'lodash';
import {EditorView} from 'prosemirror-view';
import {FcAgEditorService} from '../../../editor.service';
import Icon from '../../../icons';
import {Image as ImageCommand} from '../MenuCommands';
import {MenuService} from '../menu.service';

/**
 * Image component.
 */
@Component({
    selector: 'fc-ag-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit {

    private _imgCount: number = 0;

    private editorView: EditorView;
    
    /**
     * Default constructor.
     *
     * @param fcAgEditorService FcAgEditorService.
     * @param menuService MenuService.
     */
    constructor(
        private fcAgEditorService: FcAgEditorService,
        private menuService: MenuService
    ) {
    }
    
    /**
     * Getter for icon.
     * 
     * @returns String.
     */
    get icon(): string {
        return Icon.get('image');
    }
    
    /**
     * Get button label.
     * 
     * @param key String.
     * @returns String.
     */
    getLabel(key: string): string {
        return this.fcAgEditorService.locals.get(key);
    }
    
    /**
     * Handle insert image into editor.
     *
     * @param event Any.
     */
    insertImageHandler(event: any): void {
        const file = event.target.files[0];

        if (this.menuService.editor.options.isValidImageFile(file)) {
            const {dispatch, state} = this.editorView;
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent) => {
                const fr = e.currentTarget as FileReader;
                if (_.isNil(fr)) {
                    throw new Error('Cannot find FileReader');
                }
                // @ts-ignore
                ImageCommand.insert(fr.result.toString(), {})(state, dispatch);
            };
            reader.readAsDataURL(file);
        }
        
        // reset input for next time
        event.target.value = null;
    }

    /**
     * Angular life cycle.
     */
    ngOnInit(): void {
        this.editorView = this.menuService.editor.view;
    }
}
